import { Encoding } from "../../../utils/encoder.mjs";
import { packRecord, unpackRecord } from "../common.mjs";
import { DelegationTag, schemas } from "./schema.mjs";
/**
 * Pack delegation
 * @category delegation signature
 * @param params - Params of delegation
 * @returns Encoded delegation
 */
export function packDelegation(params) {
  return packRecord(schemas, DelegationTag, params, {}, Encoding.Bytearray);
}

/**
 * Unpack delegation
 * @category delegation signature
 * @param encoded - Encoded delegation
 * @param expectedTag - Expected delegation signature type
 * @returns Params of delegation
 */
export function unpackDelegation(encoded, expectedTag) {
  return unpackRecord(schemas, DelegationTag, encoded, expectedTag, {});
}
//# sourceMappingURL=index.mjs.map